var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',[_c('section',[_c('h2',[_vm._v("Skills")]),_vm._v(" "),_c('ul',{staticClass:"skill-bar"},_vm._l((_vm.skills),function(skill){return _c('li',{key:skill.name},[_c('span',{class:{zero: _vm.loadBar === false},style:({width: skill.percent + '%'})},[_vm._v(_vm._s(skill.percent + '%'))]),_vm._v(" "),_c('div',[_vm._v(_vm._s(skill.name))])])}))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-145d0406","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/about/AboutSkills.vue
// module id = vu0j
// module chunks = 1